import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { ETrucksActionTypes } from "./actions";

const defaultState = {
  trucks: [],
  saving: false,
  savingError: false,
  savingSuccess: false,
  deleteSuccess: false,
  deleteFailed: false
};

const persistConfig = {
  key: "trucks",
  storage,
  whitelist: ["trucks"]
};

const trucksReducer = persistReducer(
  persistConfig,
  (state = defaultState, action) => {
    switch (action.type) {
      case ETrucksActionTypes.GET_TRUCKS_SUCCESS:
        return {
          ...state,
          trucks: action.payload
        };
      case ETrucksActionTypes.SAVE_TRUCK:
        return {
          ...state,
          saving: true
        };
      case ETrucksActionTypes.SAVING_FAILED:
        return {
          ...state,
          saving: false,
          savingError: Math.random(),
          savingSuccess: false
        };
      case ETrucksActionTypes.SAVING_SUCCESS:
        return {
          ...state,
          saving: false,
          savingError: false,
          savingSuccess: Math.random()
        };
      case ETrucksActionTypes.DELETING_SUCCESS:
        return {
          ...state,
          deleteSuccess: Math.random()
        };
      case ETrucksActionTypes.RESET_SUCCESS_DELETE:
        return {
          ...state,
          deleteSuccess: false
        };
      case ETrucksActionTypes.RESET_SUCCESS_SAVE:
        return {
          ...state,
          savingSuccess: false
        };
      default:
        return state;
    }
  }
);

export default trucksReducer;
